import { Avatar, Flex, Heading } from "@chakra-ui/react";
import useSidebarV2 from "../useSidebarV2";
import sidebarV2Store from "../../../stores/sidebar-v2.store";
import teamStore from "../../../stores/team.store";

export default function Team() {
  const { textColor } = useSidebarV2()
  const { reveal } = sidebarV2Store()
  const { team } = teamStore()

  return (
    <Flex
      marginTop='16px'
      padding='10px 12px'
      borderRadius='12px'
      borderWidth='1px'
      borderColor={textColor}
      gap='12px'
      alignItems='center'
      height='44px'
    >
      <Avatar
        height='24px'
        width='24px'
        size='sm'
        name={team?.profile_globalconfig?.display_name}
        src={team?.profile_globalconfig?.logo}
      />
      <Heading 
        size='chakra_title_medium' 
        color={textColor}
        display={reveal ? 'block' : 'none'}
        isTruncated
        noOfLines={1}
      >{team?.profile_globalconfig?.display_name}</Heading>
    </Flex>
  )
}
